module.exports = __webpack_public_path__ + "img/l.90d4c940.jpg";